import Component from "@glimmer/component"
import styles from "./existing-planbooks.module.css"

export default class UserOnboardingExistingPlanbooksComponent extends Component {
  readonly styles = styles
}
